import { UserProfile } from '@clerk/clerk-react';
import { useTheme } from '~/context/ThemeContext';
import { dark } from '@clerk/themes';

interface Props {
  readonly v3Redesign?: boolean;
}

export function ClerkProfileWidget(props: Props) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  if (!props.v3Redesign) {
    return (
      <div className="h-full block overflow-x-hidden rounded-lg border border-gray-200 dark:border-[#27272a] bg-white dark:bg-[#18181b]">
        <UserProfile
          appearance={{
            baseTheme: resolvedTheme === 'dark' ? dark : undefined,
            elements: {
              rootBox: 'w-full h-full',
              cardBox:
                'rounded-none shadow-none w-full h-full min-h-[32rem] bg-white dark:bg-[#18181b]',
              navbar:
                'bg-gray-50 dark:bg-[#27272a] border-r border-gray-200 dark:border-[#27272a]',
              navbarButton: 'text-gray-700 dark:text-[#e4e4e7]',
              menuButtonEllipsis: 'hidden',
              profileSectionPrimaryButton__emailAddresses: 'hidden',
            },
          }}
        />
      </div>
    );
  }

  return (
    <section
      className="v3-card h-full p-0 overflow-x-hidden"
      data-od-id="clerk-widget"
      aria-label="Konto und Sicherheit"
    >
      <UserProfile
        appearance={{
          baseTheme: isDark ? dark : undefined,
          variables: isDark
            ? {
                colorBackground: '#18181b',
                colorInputBackground: '#27272a',
                colorInputText: '#e4e4e7',
                colorText: '#e4e4e7',
                colorTextSecondary: '#a1a1aa',
                colorPrimary: '#468cd3',
                colorNeutral: '#e4e4e7',
              }
            : {
                colorBackground: '#ffffff',
                colorInputBackground: '#ffffff',
                colorInputText: '#18181b',
                colorText: '#18181b',
                colorTextSecondary: '#52525b',
                colorPrimary: '#0052cc',
                colorNeutral: '#18181b',
              },
          elements: {
            rootBox: 'w-full h-full min-w-0',
            cardBox:
              'rounded-none shadow-none w-full h-full min-h-[32rem] bg-white dark:bg-[#18181b]',
            navbar:
              'bg-gray-50 dark:bg-[#27272a] border-r border-gray-200 dark:border-[#27272a]',
            navbarButton: 'text-gray-700 dark:text-[#e4e4e7]',
            menuButtonEllipsis: 'hidden',
            profileSectionPrimaryButton__emailAddresses: 'hidden',
          },
        }}
      />
      <p
        className="v3-src"
        style={{ padding: '0 16px 16px' }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect
            x="4"
            y="11"
            width="16"
            height="10"
            rx="2"
          />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
        Konto und Sicherheit werden von Clerk verwaltet
      </p>
    </section>
  );
}
